import { axios } from './axios';
import {
  PendingDocumentSettingsDto,
  PendingProjectSettingsDto
} from '@/jbi-shared/types/full-document-revision-object.types';

export const pendingDocumentsApi = {
  /**
   * Get document settings for a pending document
   * @param pendingDocumentId The ID of the pending document
   */
  async getDocumentSettings(pendingDocumentId: number) {
    return axios.get(`pending-documents/${pendingDocumentId}/settings`);
  },

  /**
   * Update document settings for a pending document
   * @param pendingDocumentId The ID of the pending document
   * @param settings The settings to update
   */
  async updateDocumentSettings(
    pendingDocumentId: number,
    settings: PendingDocumentSettingsDto
  ) {
    return axios.put(
      `pending-documents/${pendingDocumentId}/settings`,
      settings
    );
  },

  /**
   * Get project settings for a pending document
   * @param pendingDocumentId The ID of the pending document
   */
  async getProjectSettings(pendingDocumentId: number) {
    return axios.get(`pending-documents/${pendingDocumentId}/project-settings`);
  },

  /**
   * Update project settings for a pending document
   * @param pendingDocumentId The ID of the pending document
   * @param settings The project settings to update
   */
  async updateProjectSettings(
    pendingDocumentId: number,
    settings: PendingProjectSettingsDto
  ) {
    return axios.put(
      `pending-documents/${pendingDocumentId}/project-settings`,
      settings
    );
  }
};
